import React from "react";
import classNames from "classnames";
import "./index.scss";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon/index.js";

const SectionItemIcon = ({ column, item, value, onPropChange, withTitle = true  }) => {

  return (
    <div key={`propItem-${column.accessor}`} className={classNames("sectionItemIcon")}>
      {withTitle && <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />}

      {(column.iconName && column.iconName(value)) && <div className={'iconButton'}>
        <div className={classNames(`actionIcon ${column.iconName(value)}`)}/>
      </div>}
    </div>
  );
}

export default SectionItemIcon;
